import type { NestedStringRecord } from './NestedStringRecord.d';

/**
 * Extracts all paths to leaf nodes (where value is a string) from a nested object.
 * Returns an array of dot-notation strings representing the paths.
 */
export function getStringPaths<T extends NestedStringRecord>(obj: T, prefix: string = ''): string[] {
	const paths: string[] = [];

	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			const value = obj[key];

			// NOTE: Normally dot but dash for tailwind-merge config.
			const currentPath = prefix ? `${prefix}-${key}` : key;

			if (typeof value === "string") {
				// Leaf node (string)
				paths.push(currentPath);
			} else if (value !== null && typeof value === "object" && !Array.isArray(value)) {
				// Nested object (not array, not null)
				paths.push(...getStringPaths(value, currentPath));
			}
		// Ignore arrays, null, functions, etc.
		}
	}

	return paths;
}
